import CanvasConfetti from './CanvasConfetti';

export default CanvasConfetti;
